import { FDAlert } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

export const MFAAlert = ({ value }) => {
  return value ? <FDAlert title={value} status={'warning'} /> : null;
};

MFAAlert.propTypes = {
  value: PropTypes.string.isRequired,
};
